import React, { useState } from 'react'
import { Modal, Tooltip, Input } from 'antd'
import { Button, ColumnProps, Row, Table } from '@digital/ui'
import { GetFileExtension, imageFormats } from '@app/helpers'
import { Visibility } from '@app/components'
import { downloadAnexoRelatorioHomologacaoAprovacao, viewAnexoRelatorioHomologacaoAprovacao } from '@app/api/sas/relatorioHomologacao'

const ModalHistoricoAprovacoesArquivos = ({ arquivos, justificativa }: any) => {
    const [exibirModal, setExibirModal] = useState(false)

    const columns = () => {
        let columns: ColumnProps<any>[] = [];

        columns.push({
            title: 'Arquivo',
            dataIndex: 'nome',
            // width: '40%'
        })

        columns.push({
            title: 'Ações',
            dataIndex: '',
            width: '5%',
            render(text, record, index) {
                return <>
                    <Tooltip title="Download Arquivo">
                        <Button
                            icon="ui-download"
                            type="link"
                            onClick={() => {
                                downloadAnexoRelatorioHomologacaoAprovacao(
                                    record.id,
                                    record.nome
                                );
                            }}
                        />
                    </Tooltip>
                    <>
                        {GetFileExtension(record.nome) === "pdf" ||
                            imageFormats.includes(
                                GetFileExtension(record.nome)
                            ) ? (
                            <Tooltip title="Visualizar Arquivo">
                                <Button
                                    icon="files-view_file"
                                    type="link"
                                    onClick={() => {
                                        viewAnexoRelatorioHomologacaoAprovacao(
                                            record.id,
                                            record.nome
                                        );
                                    }}
                                />
                            </Tooltip>
                        ) : (
                            <></>
                        )}
                    </>
                </>
            },
        })


        return columns;
    }

    return (
        <>
            <Tooltip title="Visualizar Histórico do Documento">
                <Button
                    onClick={() => {
                        setExibirModal(true)
                    }}
                    icon="ui-comments"
                />
            </Tooltip>
            <Visibility
                visible={exibirModal}
            >
                <Modal
                    title="Histórico de Arquivos"
                    width="680px"
                    visible={exibirModal}
                    onCancel={() => setExibirModal(false)}
                    footer={null}
                >
                    <Row style={{ paddingBottom: '16px' }}>
                        <label>Justificativa</label>
                        <Input.TextArea value={justificativa} rows={4} disabled />
                    </Row>
                    <Visibility visible={arquivos.length > 0}>
                        <Row>
                            <Table
                                dataSource={arquivos}
                                columns={columns()}
                                rowKey="id"
                                pagination={false}
                            />
                        </Row>
                    </Visibility>
                </Modal>
            </Visibility>
        </>
    )
}

export default ModalHistoricoAprovacoesArquivos